import { BasicModalContext } from './basic-modal-context';
import { StoreConfig, OrderTypeConfig } from 'ngx-web-api';

export class OrderTypeModalContext extends BasicModalContext {
  constructor(public store: StoreConfig, public orderTypes: OrderTypeConfig[]) {
    super();
    this.config = { store, orderTypes };
  }
}
